import type { ComponentType } from 'react';
import { BlendDemo, PenDemo, RectDemo, ScissorsDemo, SelectDemo, TwirlDemo } from './demos/basics';
import { DEFORM_DEMOS } from './demos/deform';
import { EFFECTOR_DEMOS } from './demos/effectors';
import { PATH_DEMOS } from './demos/paths';
import { SHAPE_DEMOS } from './demos/shapes';

/**
 * Every tool guide's picture, by key: the tool id, or `tool:mode` for a mode that works
 * differently (see `toolFeedback`). A key missing here falls back to its tool's.
 */
export const GUIDE_DEMOS: Record<string, ComponentType> = {
  select: SelectDemo,
  rect: RectDemo,
  pen: PenDemo,
  'cut:scissors': ScissorsDemo,
  'liquify:twirl': TwirlDemo,
  blend: BlendDemo,
  ...SHAPE_DEMOS,
  ...PATH_DEMOS,
  ...DEFORM_DEMOS,
  ...EFFECTOR_DEMOS,
};

/** The picture for a key, its tool's when the mode has none of its own, else null. */
export function guideDemo(key: string): ComponentType | null {
  return GUIDE_DEMOS[key] ?? GUIDE_DEMOS[key.split(':')[0]!] ?? null;
}
